/*
 * @FilePath: /kitchen-online-web/src/redux/reducers/render.js
 * @Author: Yongchao Wang
 * @Date: 2021-08-16 13:34:27
 * @LastEditors: Yongchao Wang
 * @LastEditTime: 2021-08-16 13:44:40
 */
const renderAction = {
  calloutline: (state, payload) => ({ // 3d标注
    ...state,
    calloutline: {
      ...payload,
    },
  }),
  renderEngine: (state, payload) => ({ // 3d引擎
    ...state,
    renderEngine: {
      ...payload,
    },
  }),

};

export default renderAction;
